// extracted by mini-css-extract-plugin
export default {"wrapper":"small-loading_wrapper__mbJoC","icon":"small-loading_icon__SVnsD","spin":"small-loading_spin__eKZcc"};